/** Semantic rules for Range: an inverted min/max pair and a negative min under `exp_edit`. */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { descendsFromClass } from '../../../../godot/classdb/classBaseTypes.js';
import { boolSlotValue, scalarSlotValue } from '../../../../godot/variant/variantBool.js';
import { armEmits, groundedArm, reportArm } from '../../../../linter/ruleArms.js';
const arms = {
    maxBelowMin: {
        severity: 'error',
        ruleName: 'range-max-below-min',
        grounding: { kind: 'engine', at: 'range.cpp:229' },
    },
    expEditNegativeMin: groundedArm('range-exp-edit-negative-min', { kind: 'configuration-warning' }),
};
function checkRangeBounds(context) {
    const { node } = context;
    const diagnostics = [];
    const props = node.rawProperties;
    const minRaw = props.min_value;
    const maxRaw = props.max_value;
    // Error tier: `set_max` stores `MAX(p_max, shared->min)` (scene/gui/range.cpp:229)
    // and `set_min` raises max the same way (range.cpp:217), so either load
    // order collapses the range to a point at `min_value`. The .tscn keeps the
    // inverted pair, so without this rule the collapse is invisible.
    if (minRaw !== undefined && maxRaw !== undefined) {
        const min = scalarSlotValue(minRaw);
        const max = scalarSlotValue(maxRaw);
        // The MAX() at range.cpp:217 does not collapse a nan pair, so `nan` has
        // no single point to report.
        if (min !== null && max !== null && !Number.isNaN(min) && !Number.isNaN(max) && max < min) {
            reportArm(diagnostics, arms.maxBelowMin, node, `${node.type} '${node.name}' has 'max_value = ${maxRaw}' below 'min_value = ${minRaw}'. Godot's Range::set_max clamps max_value up to min_value rather than honouring the inverted pair, so the range collapses to a single point at ${minRaw} instead of spanning what's authored.`);
        }
    }
    // `get_configuration_warnings()` (range.cpp:71-79) warns on `exp_ratio && min < 0`.
    // `exp_edit` (range.cpp:411) defaults false and `min_value` 0.0 (range.h:40,44),
    // so both must be authored.
    if (boolSlotValue(props.exp_edit) === true && minRaw !== undefined) {
        const min = scalarSlotValue(minRaw);
        if (min !== null && !Number.isNaN(min) && min < 0) {
            reportArm(diagnostics, arms.expEditNegativeMin, node, `${node.type} '${node.name}' has 'exp_edit' enabled with 'min_value = ${minRaw}'. Exp Edit requires Min Value to be greater than or equal to 0.`);
        }
    }
    return diagnostics;
}
const rangeBoundsRule = {
    meta: {
        name: 'valid-range-bounds',
        description: 'Flags a Range whose max_value is authored below min_value, or whose Exp Edit is enabled with a negative min_value',
        category: 'validation',
        applicableNodeTypeMatcher: (nodeType) => descendsFromClass(nodeType, 'Range'),
        emits: armEmits(arms),
    },
    check: checkRangeBounds,
};
ruleRegistry.register(rangeBoundsRule);
//# sourceMappingURL=linter.js.map